module.exports = __webpack_public_path__ + "img/logo-embaixada-eslovenia.920f7fb8.webp";